import { ADD_PRODUCT } from "../../types/ProductType";

import axios from "axios";
import { toast } from "react-toastify";

const addProducAction = (data) => {
  return {
    type: ADD_PRODUCT,
    payload: data,
  };
};

export const addProduct = (values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
        url: `product/`,
        data: values,
      });
      //dispatching data
      dispatch(addProducAction(data));
      toast.success("Product Added ");
      return {
        message: "success",
      };
    } catch (error) {
      console.log(error.message);
      toast.error("Error, Check Name and Others ");
      return {
        message: "error",
      };
    }
  };
};

export const addRunningSize = (values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
        url: `running-size/`,
        data: values,
      });
      //dispatching data
      dispatch(addProducAction(data));
      toast.success("Running Size Added ");
      return {
        message: "success",
      };
    } catch (error) {
      console.log(error.message);
      toast.error(`Error: ${error.message}`);
      return {
        message: "error",
      };
    }
  };
};

export const getSingleRate = (values) => {
  return async (dispatch) => {
    try {
      const { data } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        url: `get-single-rate/`,
        data: values,
      });
      //dispatching data
      dispatch(addProducAction(data));
      toast.success("Fetched Single Rate ");
      return {
        message: "success",
        data: data,
      };
    } catch (error) {
      console.log(error.message);
      toast.error(`Error: ${error.message}`);
      return {
        message: "error",
      };
    }
  };
};
